import React from "react";
import { TableBody } from "@material-ui/core";
import _ from "lodash";
import numeral from "numeral";
import moment from "moment";

import EmptyCashflows from "./EmptyCashflows";
import CashflowHeaderRow from "./CashflowHeaderRow";
import { StyledTableCell, StyledTableHeaderCell, StyledTable, StyledCashFlowTableRow } from "./CashFlowsTable";

const CashflowRow = ({ cashflow }) => {
  const isCurrentPeriod = moment.utc().isBetween(moment.utc(cashflow.startDate), moment.utc(cashflow.endDate));

  return (
    <StyledCashFlowTableRow isCurrent={isCurrentPeriod}>
      <StyledTableCell>{moment(cashflow.startDate).utc().format("MM/YYYY")}</StyledTableCell>
      <StyledTableCell>{moment(cashflow.endDate).utc().format("MM/YYYY")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.effectiveRate).format("0.00%")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.loanBalance).format("$0,0.00")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.hedgeNotional).format("$0,0.00")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.principal).format("$0,0.00")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.interest).format("$0,0.00")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.payment).format("$0,0.00")}</StyledTableCell>
    </StyledCashFlowTableRow>
  );
};

const CombinedCashflows = ({ cashflows }) => (
  <>
    {
      _.isEmpty(cashflows) ?
        <EmptyCashflows /> :
        <StyledTable className="hide-scrollbar">
          <CashflowHeaderRow>
            <StyledTableHeaderCell>Start Date</StyledTableHeaderCell>
            <StyledTableHeaderCell>End Date</StyledTableHeaderCell>
            <StyledTableHeaderCell>Rate</StyledTableHeaderCell>
            <StyledTableHeaderCell>Loan Balance</StyledTableHeaderCell>
            <StyledTableHeaderCell>Notional</StyledTableHeaderCell>
            <StyledTableHeaderCell>Principal</StyledTableHeaderCell>
            <StyledTableHeaderCell>Interest</StyledTableHeaderCell>
            <StyledTableHeaderCell>P&amp;I Payment</StyledTableHeaderCell>
          </CashflowHeaderRow>
          <TableBody>
            {cashflows.map(x => <CashflowRow key={x.id} cashflow={x} />)}
          </TableBody>
        </StyledTable>
    }
  </>
);

export default CombinedCashflows;
